// extracted by mini-css-extract-plugin
module.exports = {"main-content":"onboarding-body__main-content___zfPFZ"};